import { Button } from "@newsela/angelou";
import { withTrackEvent, objectTypes, actionNames } from "@newsela/snitch";

import { useStandardsSearchContext } from "@/search/NewSearchPageMVP/provider/StandardsSearchProvider";
import { viewMoreButtonCss } from "./StandardsModalViewMoreButton.styles";

const ButtonWithTrackEvent = withTrackEvent(Button);

export const StandardsModalViewMoreButton = () => {
  const { handleViewMoreStandards } = useStandardsSearchContext();

  return (
    <div css={viewMoreButtonCss}>
      <ButtonWithTrackEvent
        dataProps={{ "data-qa-selector": "view-more-standards-results-button" }}
        flavor={Button.flavors.primary}
        onClick={handleViewMoreStandards}
        objectType={objectTypes.content}
        actionName={actionNames.filter}
        streamProperties={{
          description: "Load more standards in standards filter modal",
        }}
      >
        View more results
      </ButtonWithTrackEvent>
    </div>
  );
};
